import isNil from 'lodash/isNil';
import { useState, useEffect } from 'react';

import { useFeature } from '@farmersdog/ab-testing';
import { couponCookie } from '@farmersdog/coupons';

import { FeatureName } from '../../abTesting/features';

import { experimentCodesWhitelist } from './constants';
import { setCouponCookieWithDefaultExperimentCode } from './utils/setCouponCookieWithDefaultExperimentCode';

import type { AnonymousFeatures, UserFeatures } from '../../abTesting/features';

export function useDefaultDiscountExperiment() {
  const [discountChecked, setDiscountChecked] = useState<boolean>(false);
  const defaultDiscountExperiment = useFeature<
    AnonymousFeatures,
    UserFeatures,
    FeatureName
  >(FeatureName.CVR_DEFAULT_DISCOUNT, {});

  const isDefaultDiscountExperimentOn = !(
    defaultDiscountExperiment?.treatment === 'off' ||
    defaultDiscountExperiment?.treatment === 'control'
  );

  useEffect(() => {
    if (isDefaultDiscountExperimentOn && !discountChecked) {
      const currentCouponCookieCode = couponCookie.get().referrerCode;

      /*
        If user is in the experiment and ANY NON-DEFAULT coupon cookie value exists, we will not overwrite it.
        If user is in the experiment and a DEFAULT coupon cookie value exists, 
        we will overwrite it with the latest code returned from split.
      */
      const currentCouponCookieIsDefaultDiscount =
        currentCouponCookieCode &&
        experimentCodesWhitelist.has(currentCouponCookieCode);

      if (
        isNil(currentCouponCookieCode) ||
        currentCouponCookieIsDefaultDiscount
      ) {
        setCouponCookieWithDefaultExperimentCode({
          splitConfig: defaultDiscountExperiment?.config || {},
        });
      }
      setDiscountChecked(true);
    }
  }, [
    isDefaultDiscountExperimentOn,
    defaultDiscountExperiment?.config,
    discountChecked,
    setDiscountChecked,
  ]);
  return discountChecked;
}
